export default "__VITE_ASSET__DWt7jsrW__"